import DefaultInput from "../../components/inputs/DefaultInput";

export default function CityFormFields({ form, city }: any) {

    const isTimeBefore = (from: string, to: string) => {
        if (!from || !to) return true; // se uno dei due non è valorizzato, non mostrare errore
        const [fromH, fromM] = from.split(":").map(Number);
        const [toH, toM] = to.split(":").map(Number);
        return fromH <= toH || (fromH === toH && fromM <= toM);
    };

    // Validator generico per un range
    const validateTimeRange = (fromField: string, toField: string) => {
        const from = form.getValues(fromField);
        const to = form.getValues(toField);
        return isTimeBefore(from, to) || "Errore orario";
    };

      return (
    <div className="border rounded-lg p-4 bg-white shadow-sm">
      <h3 className="text-base font-semibold text-gray-800 mb-4">
        {city.toUpperCase()}
      </h3>

      {/* MATTINA */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 mb-3">
        <span className="text-sm text-gray-700 w-full sm:w-24">Mattina</span>
        <div className="flex gap-2 w-full">
          <DefaultInput
            form={form}
            input={{
              name: `${city}.orarioMattinaFrom`,
              type: "time",
              size_input: "w-1/2",
              validators: { 
                required: "Obbligatorio",
                validate: () =>
                  validateTimeRange(`${city}.orarioMattinaFrom`, `${city}.orarioMattinaTo`)
              },
            }}
          />
          <DefaultInput
            form={form}
            input={{
              name: `${city}.orarioMattinaTo`,
              type: "time",
              size_input: "w-1/2",
              validators: { 
                required: "Obbligatorio",
                validate: () =>
                  validateTimeRange(`${city}.orarioMattinaFrom`, `${city}.orarioMattinaTo`)
              },
            }}
          />
        </div>
      </div>

      {/* POMERIGGIO */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 mb-4">
        <span className="text-sm text-gray-700 w-full sm:w-24">Pomeriggio</span>
        <div className="flex gap-2 w-full">
          <DefaultInput
            form={form}
            input={{
              name: `${city}.orarioPomeriggioFrom`,
              type: "time",
              size_input: "w-1/2",
              validators: { 
                required: "Obbligatorio",
                validate: () =>
                  validateTimeRange(`${city}.orarioPomeriggioFrom`, `${city}.orarioPomeriggioTo`)
              },
            }}
          />
          <DefaultInput
            form={form}
            input={{
              name: `${city}.orarioPomeriggioTo`,
              type: "time",
              size_input: "w-1/2",
              validators: { 
                required: "Obbligatorio",
                validate: () =>
                  validateTimeRange(`${city}.orarioPomeriggioFrom`, `${city}.orarioPomeriggioTo`)
              },
            }}
          />
        </div>
      </div>

      {/* LIMITI */}
      <div className="flex flex-col gap-y-6 pt-4">
        <DefaultInput
          form={form}
          input={{
            name: `${city}.limiteAppuntamenti`,
            label: "App. giornalieri",
            type: "number",
            size_input: "w-full",
            validators: {},
          }}
        />
        <DefaultInput
          form={form}
          input={{
            name: `${city}.limiteSimultaneiMattina`,
            label: "App. simult. mattina",
            type: "number",
            size_input: "w-full",
            validators: {},
          }}
        />
        <DefaultInput
          form={form}
          input={{
            name: `${city}.limiteSimultaneiPomeriggio`,
            label: "App. simult. pomeriggio",
            type: "number",
            size_input: "w-full",
            validators: {},
          }}
        />
      </div>
    </div>
  );

}
